module.exports = __webpack_public_path__ + "static/media/inAHurryBikeActive.166b1047.png";